import { ClassCast } from '@shared/zb-object-helper/class-cast';
import { DockGroupModel } from './dock-group.model';

export class DockModel {
  themeId: string = undefined;
  planId: string = undefined;
  @ClassCast(DockGroupModel)
    dockGroups: DockGroupModel[] = [];
}
